<template>
  <div :class="wrapperClasses">
    <div :class="labelClasses">{{ label }}:</div>
    <div :class="valueClasses">
      {{ value }}
      <slot v-if="!hasContent">-</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    horizontal: Boolean,
    value: [String, Number],
    strong: Boolean,
    big: Boolean,
  },
  computed: {
    wrapperClasses() {
      return {
        'd-flex': this.horizontal,
        'align-items-center': true,
        'mr-5': this.horizontal,
      };
    },
    labelClasses() {
      return {
        'info-data--label': true,
        'mr-2': this.horizontal,
      };
    },
    valueClasses() {
      return {
        'info-data--value': true,
        'is-strong': this.strong,
        'is-big': this.big,
      };
    },
    hasContent() {
      return !!this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_colors.scss';

.info-data {
  &--label {
    font-size: 12px;
    font-weight: bold;
    color: $mutedGray;
  }

  &--value {
    &.is-big {
      font-size: 18px;
    }

    &.is-strong {
      font-weight: bold;
    }
  }
}
</style>

